<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="auto-register-wrapper"
    :style="{ backgroundImage: 'url(' + storeinfo.image_header + ')' }"
  >
    <div class="auto-register-body">
      <div class="head-section">
        <img
          class="logo-auto-register"
          crm_at="logo_auto_register"
          :src="storeinfo.image_logo"
          alt=""
        />
        <div class="auto-register-title" crm_at="auto-register-title">
          {{ lbl.default.welcome }}<br />
          {{ storeinfo.businessName }}
        </div>
      </div>
      <div class="form-register-section">
        <span class="form-title">
          {{ lbl.companycrm.pleasefillverifycode.name }}
        </span>
        <div v-if="!flowCode" class="mobile-number-container">
          <label class="mobile-number-input-text" for="mobileNumber">
            {{ lbl.autologin.register_otp.mobile_label }}
          </label>
          <div class="input-container">
            <input
              id="mobileNumber"
              v-model="mobileNumber"
              crm_at="mobileNumber"
              type="tel"
              class="input-container mobile-number-input"
              :class="{ error: isMoblieNumberDuplicate }"
              :placeholder="lbl.autologin.register_otp.mobile_placeholder"
              @keypress="onlyNumber"
              @keyup="keyUp"
            />
            <button
              v-if="isMoblieNumberDuplicate"
              id="clear-text-button"
              class="clear-text-button"
              @click="clearTextMobileNumber()"
            >
              <img
                src="@/assets/images/error-circle-icon.svg"
                alt="error circle icon"
              />
            </button>
          </div>

          <label v-show="isMoblieNumberDuplicate" class="error-text">
            {{ lbl.autologin.register_otp.error_duplicate }}
          </label>
        </div>
        <div v-if="flowOtpAndCode" class="line" />
        <div v-if="!flowOtp" class="reference-container">
          <div class="reference-1-container">
            <label class="reference-input-text" for="verifyCode1">
              {{ companyText.headerText1 }}
            </label>
            <div class="input-container">
              <input
                id="reference-1-input"
                v-model="verifyCode1"
                :placeholder="companyText.placeholderText1"
                class="reference-input"
                :class="{ error: isReferenceInfoDuplicate }"
                type="text"
                name="verifyCode1"
              />
              <button
                v-if="isReferenceInfoDuplicate"
                id="clear-text-button"
                class="clear-text-button"
                @click="clearTextReferenceInfo()"
              >
                <img
                  src="@/assets/images/error-circle-icon.svg"
                  alt="error circle icon"
                />
              </button>
            </div>

            <label v-show="isReferenceInfoDuplicate" class="error-text">
              {{ lbl.autologin.register_code.error_messege }}
            </label>
          </div>
          <div class="verifyCode2">
            <label class="reference-input-text" for="verifyCode2">
              {{ companyText.headerText2 }}
            </label>
            <div class="input-container">
              <input
                id="reference-2-input"
                v-model="verifyCode2"
                :placeholder="companyText.placeholderText2"
                class="reference-input"
                :class="{ error: isReferenceInfo2Duplicate }"
                type="text"
                name="verifyCode2"
              />
              <button
                v-if="isReferenceInfo2Duplicate"
                id="clear-text-button"
                class="clear-text-button"
                @click="clearTextReferenceInfo2()"
              >
                <img
                  src="@/assets/images/error-circle-icon.svg"
                  alt="error circle icon"
                />
              </button>
            </div>

            <label v-show="isReferenceInfo2Duplicate" class="error-text">
              {{ lbl.autologin.register_code.error_messege }}
            </label>
          </div>
        </div>
        <div class="manaul-detail-section" v-html="manualDetial" />
        <button
          id="submit-button"
          type="submit"
          value="Submit"
          class="submit-button"
          :class="{ disable: isDisabled }"
          :style="{
            backgroundColor: storeinfo.buttoncolor,
            border: storeinfo.buttoncolor,
            color: storeinfo.buttontextcolor,
          }"
          :disabled="isDisabled"
          @click="summitCompanycrm()"
        >
          {{ textButton }}
        </button>
      </div>
    </div>
    <div v-if="isshowalert">
      <AlertErrormodal
        v-if="isshowalert && errors.length > 0"
        :isshowalert="isshowalert"
        :modalcontent="errors"
        :title="title"
      />
    </div>

    <AlertError
      :show="showError"
      :data="dataError"
      @changeError="ChangeError($event)"
    />
    <OtpCompanymodal
      v-if="isSentOtp"
      :is-sent-otp="isSentOtp"
      :params="otp_params"
      :obj-profile-info="objProfileInfo"
      :storeinfo="storeinfo"
      :result-otp.sync="verifyOTPSuccess"
      :is-use-single-user-account="isUseSingleUserAccount"
      @ChangeCloseOtp="ChangeCloseOtp($event)"
      @closePopup="isSentOtp = false"
    />

    <VerifySuccessModal
      v-if="isVerifySuccess"
      :button-color="storeinfo.buttoncolor"
      :button-text-color="storeinfo.buttontextcolor"
      @verifySuccess="verifySuccess()"
    />
    <RegisterSuccessModal
      v-if="isRegisterSuccess"
      :is-show="isRegisterSuccess"
      :button-color="storeinfo.buttoncolor"
      :button-text-color="storeinfo.buttontextcolor"
      @registerSuccess="registerSuccess()"
    />
  </div>
</template>
<script>
import Account from '@/helper/AccountHelper.js'
import AlertErrormodal from '@/components/Modal/AlertErrormodal.vue'
import AlertError from '@/components/Modal/AlertError'
import BzbsApi from '@/core/Http/BzbsApi.js'
import BzbsCompanycrm from '@/core/companycrm/BzbsCompanycrm'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import BzbsLogin from '@/core/Account/service/BzbsLogin'
import BzbsProfile from '@/core/Account/service/BzbsProfile.js'
import Cache from '@/helper/Cache.js'
import Config from '@/helper/Config.js'
import CommonMixin from '@/mixin/CommonMixin'
import moment from 'moment-timezone'
import OtpCompanymodal from '@/components/Modal/Otpmodal.vue'
import RegisterSuccessModal from '@/components/Modal/RegisterSuccessModal.vue'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import VerifySuccessModal from '@/components/Modal/VerifySuccessModal.vue'
import Vue from 'vue'
import _ from 'lodash'

export default {
  name: 'AutoRegister',
  components: {
    OtpCompanymodal,
    RegisterSuccessModal,
    AlertErrormodal,
    AlertError,
  },

  mixins: [CommonMixin, ResponsiveMixin, VerifySuccessModal],
  data() {
    return {
      storeinfo: {
        image_header: '',
        image_logo: '',
        businessName: '',
      },
      isUseSingleUserAccount: false,
      isCompany: null,
      isCompanyVerifyWithOtp: null,
      loginType: null,
      flowOtp: false,
      flowCode: false,
      flowOtpAndCode: false,
      mobileNumber: '',
      verifyCode1: '',
      verifyCode2: '',
      lengthMobile: 10,
      isMoblieNumberDuplicate: false,
      isReferenceInfoDuplicate: false,
      isReferenceInfo2Duplicate: false,
      isVerifySuccess: false,
      objProfileInfo: {},
      companyText: {
        headerText1: null,
        headerText2: null,
        placeholderText1: null,
        placeholderText2: null,
      },
      sponsorId: '',
      manualDetial: '',
      locale: '',
      textButton: '',
      objVerifyCustomerUser: null,
      isSentOtp: false,
      isRegisterSuccess: false,
      title: {
        line1: '',
        line2: '',
      },
      titlesuccess: {},
      isshowalert: false,
      errors: [],
      showError: false,
      dataError: {},
      haserrors: false,
      ispass: false,
      otp_params: {
        contact_number: '',
        app_id: '',
        channel: 'update',
      },
      catchdate: {
        date: null,
        month: null,
        year: null,
        timestamp: null,
      },
      verifiCodeParams: {},
      companyVerifyCount: null,
    }
  },
  computed: {
    isDisabled() {
      if (this.flowOtpAndCode) {
        return (
          this.mobileNumber.length !== this.lengthMobile ||
          this.verifyCode1.length === 0 ||
          this.verifyCode2.length === 0
        )
      } else if (this.flowOtp) {
        return this.mobileNumber.length !== this.lengthMobile
      } else if (this.flowCode) {
        return this.verifyCode1.length === 0 || this.verifyCode2.length === 0
      } else {
        return false
      }
    },
  },
  watch: {
    mobileNumber(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.isMoblieNumberDuplicate = false
      }
    },
    verifyCode1(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.isReferenceInfoDuplicate = false
      }
    },
    verifyCode2(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.isReferenceInfo2Duplicate = false
      }
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId == 'otp_company_modal') {
        this.isSentOtp = false
        this.mobileNumber = ''
        this.verifyCode1 = ''
        this.verifyCode2 = ''
      }
    })
  },
  created() {
    this.handleFooter(false)
    Vue.$cookies.remove('RegisterStore_' + Account.getCacheCustom('app_id'))
    this.checklocalStorage().then(() => {
      if (!this.$route.query.single_signon) {
        this.handleCheckLogin(this.$route)
      }
      this.init()
    })
  },
  methods: {
    isTablet() {
      if (screen.width >= 768) {
        return true
      } else {
        return false
      }
    },
    init() {
      this.lengthMobile = Vue.bzbsConfig.businessRule.max.phoneLength
      this.textButton = this.lbl.btn.submit
      this.locale = Cache.get('BzbsLocale')
      this.handleLanguage(true)
      Promise.all([this.getCustomerStore(), this.getManualDetail()]).then(
        () => {
          this.handleLoading(false)
        },
      )
    },
    handleLoading(value) {
      this.$store.commit('Loading', value)
    },
    clearTextMobileNumber() {
      this.mobileNumber = ''
      this.isMoblieNumberDuplicate = false
    },

    clearTextReferenceInfo() {
      this.verifyCode1 = ''
      this.isReferenceInfoDuplicate = false
    },
    clearTextReferenceInfo2() {
      this.verifyCode2 = ''
      this.isReferenceInfo2Duplicate = false
    },
    setParams() {
      return new Promise(resolve => {
        if (this.flowOtpAndCode) {
          Account.setCacheCustomByAppId('verifyCode1', this.mobileNumber)
          Account.setCacheCustomByAppId('verifyCode2', this.verifyCode1)
          Account.setCacheCustomByAppId('verifyCode3', this.verifyCode2)

          this.verifiCodeParams = {
            verifyCode1: this.mobileNumber,
            verifyCode2: this.verifyCode1,
            verifyCode3: this.verifyCode2,
          }
        } else if (this.flowOtp) {
          Account.setCacheCustomByAppId('verifyCode1', this.mobileNumber)

          this.verifiCodeParams = {
            verifyCode1: this.mobileNumber,
          }
        } else {
          Account.setCacheCustomByAppId('verifyCode1', this.verifyCode1)
          Account.setCacheCustomByAppId('verifyCode2', this.verifyCode2)

          this.verifiCodeParams = {
            verifyCode1: this.verifyCode1,
            verifyCode2: this.verifyCode2,
          }
        }
        resolve(true)
      })
    },
    summitCompanycrm() {
      this.handleLoading(true)
      this.setParams().then(() => {
        BzbsCompanycrm.apiVerifyCustomerUser(this.verifiCodeParams)
          .then(response => {
            console.log('apiVerifyCustomerUser data :: ', response)
            this.isshowalert = false
            this.isRegisterSuccess = false
            this.errors = []
            Account.setCacheCustom('cuscompusr', JSON.stringify(response))
            this.objVerifyCustomerUser = response.data
            var datestore = Number(
              moment.unix(this.objVerifyCustomerUser.BirthDate).format('DD'),
            )
            var month_number = moment
              .unix(this.objVerifyCustomerUser.BirthDate)
              .format('MM')
            var yearstore = moment
              .unix(this.objVerifyCustomerUser.BirthDate)
              .format('YYYY')
            var registerstore = {
              name: this.objVerifyCustomerUser.FirstName,
              lastname: this.objVerifyCustomerUser.LastName,
              mobilenumber: this.objVerifyCustomerUser.Tel,
              email: this.objVerifyCustomerUser.Email,
              radioGender: this.objVerifyCustomerUser.Gender.toLowerCase(),
              verifyCode1: this.objVerifyCustomerUser.VerifyCode1,
              verifyCode2: this.objVerifyCustomerUser.VerifyCode2,
              verifyCode3: this.objVerifyCustomerUser.VerifyCode3,
            }
            Account.setCacheCustom(
              'RegisterStore_' + Account.getCacheCustom('app_id'),
              registerstore,
            )

            this.catchdate.date = datestore
            this.catchdate.month = month_number
            this.catchdate.year = yearstore
            Account.setCacheCustom(
              'catchdate_' + Account.getCacheCustom('app_id'),
              this.catchdate,
            )
            // if (this.storeinfo.AllowBrandA) {
            //   const target_page = Account.getCacheCustomByAppId('target_page')
            //   var redirectUri = Account.getCacheCustomByAppId(
            //     'redirectUriecomurl',
            //   )
            //   this.checkEcomurlParam(redirectUri).then(url => {
            //     if (url) {
            //       const ecomurl = target_page + '?redirectUri=' + url
            //       Account.setCacheEcomByAppId(ecomurl)
            //       Account.removeCacheCustomByAppId('redirectUriecomurl')
            //       window.open(encodeURI(url), '_self')
            //     }
            //   })
            // } else {
            if (this.objVerifyCustomerUser.UserId) {
              this.handleLoading(false)
              // registered before
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: 'This user has already been taken.',
              }
            } else {
              // go to flow import
              var target_page = ''
              if (this.$route.query.target_page != undefined) {
                target_page = this.$route.query.target_page
              } else if (this.$route.query.returnURL != undefined) {
                target_page = this.$route.query.returnURL
              } else {
                target_page = 'home'
              }
              var redirectUri = ''
              if (this.$route.query.redirectUri != undefined) {
                redirectUri = this.$route.query.target_page
              } else {
                redirectUri = ''
              }

              if (this.storeinfo.IsSkipRegister) {
                if (
                  this.storeinfo.UseOTP &&
                  !Vue.bzbsConfig.businessRule.webFor.PH
                ) {
                  if (redirectUri) {
                    window.location =
                      '/termandcondition?single_signon=true&skip_register=true&useOTP=true' +
                      '&target_page=' +
                      target_page +
                      '&redirectUri=' +
                      redirectUri +
                      '&id_token=' +
                      this.$route.query.id_token +
                      '&verifyCode1=' +
                      Account.getCacheCustomByAppId('verifyCode1') +
                      '&verifyCode2=' +
                      Account.getCacheCustomByAppId('verifyCode2') +
                      '&verifyCode3=' +
                      Account.getCacheCustomByAppId('verifyCode3')
                  } else {
                    window.location =
                      '/termandcondition?single_signon=true&skip_register=true&useOTP=true' +
                      '&target_page=' +
                      target_page +
                      '&id_token=' +
                      this.$route.query.id_token +
                      '&verifyCode1=' +
                      Account.getCacheCustomByAppId('verifyCode1') +
                      '&verifyCode2=' +
                      Account.getCacheCustomByAppId('verifyCode2') +
                      '&verifyCode3=' +
                      Account.getCacheCustomByAppId('verifyCode3')
                  }
                } else {
                  if (redirectUri) {
                    window.location =
                      '/termandcondition?single_signon=true&skip_register=true' +
                      '&target_page=' +
                      target_page +
                      '&redirectUri=' +
                      redirectUri +
                      '&id_token=' +
                      this.$route.query.id_token +
                      '&verifyCode1=' +
                      Account.getCacheCustomByAppId('verifyCode1') +
                      '&verifyCode2=' +
                      Account.getCacheCustomByAppId('verifyCode2') +
                      '&verifyCode3=' +
                      Account.getCacheCustomByAppId('verifyCode3')
                  } else {
                    window.location =
                      '/termandcondition?single_signon=true&skip_register=true' +
                      '&target_page=' +
                      target_page +
                      '&id_token=' +
                      this.$route.query.id_token +
                      '&verifyCode1=' +
                      Account.getCacheCustomByAppId('verifyCode1') +
                      '&verifyCode2=' +
                      Account.getCacheCustomByAppId('verifyCode2') +
                      '&verifyCode3=' +
                      Account.getCacheCustomByAppId('verifyCode3')
                  }
                }
              } else {
                if (redirectUri) {
                  window.location =
                    '/register?single_signon=true' +
                    '&target_page=' +
                    target_page +
                    '&id_token=' +
                    this.$route.query.id_token +
                    '&verifyCode1=' +
                    Account.getCacheCustomByAppId('verifyCode1') +
                    '&verifyCode2=' +
                    Account.getCacheCustomByAppId('verifyCode2') +
                    '&verifyCode3=' +
                    Account.getCacheCustomByAppId('verifyCode3')
                } else {
                  window.location =
                    '/register?single_signon=true' +
                    '&target_page=' +
                    target_page +
                    '&redirectUri=' +
                    redirectUri +
                    '&id_token=' +
                    this.$route.query.id_token +
                    '&verifyCode1=' +
                    Account.getCacheCustomByAppId('verifyCode1') +
                    '&verifyCode2=' +
                    Account.getCacheCustomByAppId('verifyCode2') +
                    '&verifyCode3=' +
                    Account.getCacheCustomByAppId('verifyCode3')
                }
              }
            }
            // }
          })
          .catch(error => {
            console.log('error verify code :: ', error)
            this.handleLoading(false)
            if (error.response.status === 404) {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: error.response.data.error.message,
              }
            } else if (error.response.status === 401) {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.you_not_authorized_to_use,
              }
            } else {
              this.isMoblieNumberDuplicate = true
              this.isReferenceInfoDuplicate = true
              this.isReferenceInfo2Duplicate = true
            }
          })
      })
    },
    checkEcomurlParam(url) {
      return new Promise(resolve => {
        var token = Account.getCacheToken() ? Account.getCacheToken() : null

        if (url.includes('?')) {
          if (token) {
            let link =
              url +
              '&token=' +
              token +
              '&app_id=' +
              Account.getCacheCustom('app_id')
            resolve(link)
          } else {
            let link = url + '&app_id=' + Account.getCacheCustom('app_id')
            resolve(link)
          }
        } else {
          if (token) {
            let link =
              url +
              '?token=' +
              token +
              '&app_id=' +
              Account.getCacheCustom('app_id')
            resolve(link)
          } else {
            let link = url + '?app_id=' + Account.getCacheCustom('app_id')
            resolve(link)
          }
        }
      })
    },
    success() {
      this.handleLoading(false)
      var target_page = ''
      if (this.$route.query.target_page != undefined) {
        target_page = this.$route.query.target_page
      } else if (this.$route.query.returnURL != undefined) {
        target_page = this.$route.query.returnURL
      } else {
        target_page = 'home'
      }
      //old flow
      if (this.isCompanyVerifyWithOtp) {
        this.handleLoading(false)
        this.isVerifySuccess = true
      }
      //new flow
      if (this.storeinfo.IsSkipRegister) {
        if (!(this.isCompany && this.isBrandA)) {
          window.location = '/termandcondition'
        } else {
          this.isRegisterSuccess = true
          this.$bvModal.show('register-success-modal')
        }
      } else {
        if (Account.getCacheCustomByAppId('target_page') == 'ecomurl') {
          window.location =
            '/register?target_page=' +
            target_page +
            '?token=' +
            Account.getCacheToken() +
            +'&app_id=' +
            Account.getCacheCustom('app_id') +
            '&goback=companycrm'
        } else if (target_page) {
          window.location =
            '/register?target_page=' + target_page + '&goback=companycrm'
        } else {
          window.location = '/register?target_page=/home' + '&goback=companycrm'
        }
      }
    },
    verifyOTPSuccess() {
      this.handleLoading(false)
      console.log('verify OTP Auto Register Success :: ')
      this.success()
    },
    successIsskipregister() {
      this.handleLoading(false)
      var target_page = ''
      if (this.$route.query.target_page != undefined) {
        target_page = this.$route.query.target_page
      } else if (this.$route.query.returnURL != undefined) {
        target_page = this.$route.query.returnURL
      } else {
        target_page = 'home'
      }
      this.$success({
        title: this.lbl.companycrm.successtext.name,
        okText: this.lbl.btn.ok,
        centered: true,
        onOk() {
          window.location =
            '/register?verifyCode1=' +
            Account.getCacheCustomByAppId('verifyCode1') +
            '&verifyCode2=' +
            Account.getCacheCustomByAppId('verifyCode2') +
            '&verifyCode3=' +
            Account.getCacheCustomByAppId('verifyCode3') +
            '&target_page=' +
            target_page +
            '&goback=companycrm'
        },
      })
    },
    toTimestamp(strDate) {
      var datum = Date.parse(strDate)
      return datum / 1000
    },
    callAPIcompanyuser() {
      this.handleLoading(true)
      var params = {
        verifyCode1: Account.getCache(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
        ).verifyCode1,
        verifyCode2: Account.getCache(
          'BzbsUser_' + Account.getCacheCustom('app_id'),
        ).verifyCode2,
      }
      BzbsCompanycrm.apicompanyuser(params)
        .then(data => {
          console.log('apicompanyuser :: ', data)
          this.handleLoading(false)
          this.success()
        })
        .catch(() => {
          this.handleLoading(false)
          this.isshowalert = true
          this.errors = []
          this.errors.push({
            name: this.lbl.companycrm.popuperror.name,
            action: this.lbl.companycrm.unauthtext.name,
          })
        })
    },
    getCustomerStore() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            this.genInfo(res)
            if (!this.$route.query.single_signon) {
              this.getprofileinit()
            }
            this.checkFlow(res)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    genInfo(res) {
      this.getConfigCompanytext()
      this.storeinfo.image_header = res.data.StoreDetail.CoverUrl
      this.storeinfo.image_logo = res.data.StoreDetail.LogoUrl
      this.storeinfo.businessName = res.data.StoreDetail.BusinessName
      this.storeinfo.buttoncolor = res.data.StoreDetail.ButtonColor
      this.storeinfo.buttontextcolor = res.data.StoreDetail.ButtonTextColor
      this.storeinfo.IsSkipRegister = res.data.StoreDetail.IsSkipRegister
      this.storeinfo.UseOTP = res.data.UseOTP
      this.storeinfo.CompanyVerifyWithOtp =
        res.data.StoreDetail.CompanyVerifyWithOtp
      this.storeinfo.IsCompany = res.data.StoreDetail.IsCompany
      this.storeinfo.AllowBrandA = res.data.StoreDetail.AllowBrandA
      this.isBrandA = res.data.IsBrandA
      this.loginType = res.data.StoreDetail.LoginType
      this.isCompany = res.data.StoreDetail.IsCompany
      this.directBrandAUrl = res.data.StoreDetail.DirectBrandA
      this.isUseSingleUserAccount = res.data.UseSingleUserAccount
    },
    getprofileinit() {
      BzbsProfile.getProfile(
        Account.getCacheToken() ? Account.getCacheToken() : null,
      )
        .then(res => {
          this.ExtensionJsonProperty = res.data.ExtensionJsonProperty
          this.checkDirectBrandA()
        })
        .catch(error => {
          if (_.isEmpty(error.response)) {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: this.lbl.error.connectionproblem,
            }
          }
          this.showError = true
          this.dataError = {
            title: this.lbl.error.errortitle,
            detail: error.response.data.error.message,
          }
          console.log(error)
        })
    },
    checkDirectBrandA() {
      if (
        this.isBrandA &&
        this.isCompany &&
        this.directBrandAUrl &&
        this.ExtensionJsonProperty &&
        this.ExtensionJsonProperty.registered
      ) {
        var token = Account.getCacheToken() ? Account.getCacheToken() : null
        var directUrl = this.directBrandAUrl
        if (directUrl.includes('?')) {
          directUrl =
            directUrl +
            '&token=' +
            token +
            '&app_id=' +
            Account.getCacheCustom('app_id')
        } else {
          directUrl =
            directUrl +
            '?token=' +
            token +
            '&app_id=' +
            Account.getCacheCustom('app_id')
        }
        window.open(encodeURI(directUrl), '_self')
      }
      this.handleLoading(false)
    },
    checkFlow(res) {
      this.isCompany = res.data.StoreDetail.IsCompany
      this.isCompanyVerifyWithOtp = res.data.StoreDetail.CompanyVerifyWithOtp
      this.companyVerifyCount = res.data.StoreDetail.CompanyVerifyCount
      if (
        this.isCompanyVerifyWithOtp &&
        this.isCompany &&
        this.companyVerifyCount == 1
      ) {
        this.flowOtp = true
      } else if (
        this.isCompanyVerifyWithOtp &&
        this.isCompany &&
        this.companyVerifyCount == 3
      ) {
        this.flowOtpAndCode = true
      } else {
        this.flowCode = true
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      const regex = /^[0-9]\d*$/
      var match = $event.key.match(regex)
      if (((keyCode < 48 || keyCode > 57) && keyCode !== 46) || match == null) {
        $event.preventDefault()
      }
    },
    keyUp($event) {
      if ($event.target.value) {
        var thenum = $event.target.value
          .replace(/\D/g, '')
          .slice(0, parseInt(this.lengthMobile))
        this.mobileNumber = thenum
      }
    },
    getConfigCompanytext() {
      console.log('this.lbl.companycrm :: ', this.lbl.companycrm)
      Config.getConfigCompanytext()
        .then(res => {
          const locale = Cache.get('BzbsLocale')
          if (locale === 'en') {
            this.companyText.headerText1 = res.header1_en
            this.companyText.headerText2 = res.header2_en
            this.companyText.placeholderText1 = res.placeholder1_en
            this.companyText.placeholderText2 = res.placeholder2_en
            return
          }
          this.companyText.headerText1 = res.header1
          this.companyText.headerText2 = res.header2
          this.companyText.placeholderText1 = res.placeholder1
          this.companyText.placeholderText2 = res.placeholder2
        })
        .catch(() => {
          this.companyText.headerText1 = this.lbl.companycrm.referrencecode1.name
          this.companyText.headerText2 = this.lbl.companycrm.referrencecode2.name
          this.companyText.placeholderText1 = this.lbl.companycrm.referrencecode1.placeholder
          this.companyText.placeholderText2 = this.lbl.companycrm.referrencecode2.placeholder
        })
    },
    getManualDetail() {
      this.getSponsorId().then(() => {
        var blobConfigUrl =
          Vue.bzbsConfig.bzbBlobUrl +
          '/buzzportaldocument/' +
          this.sponsorId +
          '/localization'

        BzbsApi.connectBzbsGetBlob(blobConfigUrl).then(res => {
          if (this.locale === 'th') {
            this.manualDetial = res.data[1].detail
          } else {
            this.manualDetial = res.data[0].detail
          }
        })
      })
    },
    getSponsorId() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsLogin.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            this.sponsorId = res.data.SponsorId
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    verifySuccess() {
      if (this.isBrandA && this.isCompany && this.directBrandAUrl) {
        var token = Account.getCacheToken() ? Account.getCacheToken() : null
        var directUrl = this.directBrandAUrl
        if (directUrl.includes('?')) {
          directUrl =
            directUrl +
            '&token=' +
            token +
            '&app_id=' +
            Account.getCacheCustom('app_id')
        } else {
          directUrl =
            directUrl +
            '?token=' +
            token +
            '&app_id=' +
            Account.getCacheCustom('app_id')
        }
        window.open(encodeURI(directUrl), '_self')
      } else {
        var target_page
        if (this.$route.query.target_page != undefined) {
          target_page = this.$route.query.target_page
        } else if (this.$route.query.returnURL != undefined) {
          target_page = this.$route.query.returnURL
        } else {
          target_page = 'home'
        }
        if (this.storeinfo.IsSkipRegister) {
          if (Account.getCacheCustomByAppId('target_page') == 'ecomurl') {
            window.location =
              target_page + '?token=' + Account.getCacheToken()
                ? Account.getCacheToken() +
                  '&app_id=' +
                  Account.getCacheCustom('app_id')
                : null
          } else if (target_page) {
            window.location = target_page
          } else {
            window.location = '/home'
          }
        } else {
          if (Account.getCacheCustomByAppId('target_page') == 'ecomurl') {
            window.location =
              '/register?target_page=' +
              target_page +
              '?token=' +
              Account.getCacheToken() +
              '&app_id=' +
              Account.getCacheCustom('app_id') +
              '&goback=companycrm'
          } else if (target_page) {
            window.location =
              '/register?target_page=' + target_page + '&goback=companycrm'
          } else {
            window.location =
              '/register?target_page=/home' + '&goback=companycrm'
          }
        }
      }
    },
    registerSingleSignOn() {
      return new Promise(resolve => {
        if (this.$route.query.single_signon && this.isUseSingleUserAccount) {
          this.handleLoading(true)
          var strExtendJson = {}
          if (this.storeinfo.IsCompany || this.storeinfo.CompanyVerifyWithOtp) {
            strExtendJson.verifiedConpanyUser = true
          }
          if (
            !_.isEmpty(this.ReferenceInfo) &&
            !_.isEmpty(this.ReferenceInfo2)
          ) {
            strExtendJson.registered = true
            strExtendJson.reference_info = this.ReferenceInfo
            strExtendJson.reference_info2 = this.ReferenceInfo2
          } else if (
            !_.isEmpty(this.ReferenceInfo) &&
            _.isEmpty(this.ReferenceInfo2)
          ) {
            strExtendJson.registered = true
            strExtendJson.reference_info = this.ReferenceInfo
            strExtendJson.reference_info2 = ''
          } else if (
            _.isEmpty(this.ReferenceInfo) &&
            !_.isEmpty(this.ReferenceInfo2)
          ) {
            strExtendJson.registered = true
            strExtendJson.reference_info = ''
            strExtendJson.reference_info2 = this.ReferenceInfo2
          } else {
            strExtendJson.registered = true
            strExtendJson.reference_info = ''
            strExtendJson.reference_info2 = ''
          }
          let params = {}

          var tokenType = this.loginType.toLowerCase().includes('facebook')
            ? 'facebook'
            : this.loginType.toLowerCase().includes('line')
            ? 'line'
            : this.loginType.toLowerCase().includes('email')
            ? 'email'
            : 'line'

          params = {
            id_token: this.$route.query.id_token,
            app_id: Account.getCacheCustom('app_id'),
            tokenType: tokenType,
            os: 'web',
            firstname: this.objVerifyCustomerUser.data.FirstName,
            lastname: this.objVerifyCustomerUser.data.LastName,
            birthdate: this.objVerifyCustomerUser.data.BirthDat,
            gender: this.objVerifyCustomerUser.data.Gender
              ? this.objVerifyCustomerUser.data.Gender.toLowerCase()
              : null,
            contact_number: this.objVerifyCustomerUser.data.Tel,
            extendjsonstring: strExtendJson,
            custom_info: {
              verifyCode1: this.objVerifyCustomerUser.data.VerifyCode1,
              verifyCode2: this.objVerifyCustomerUser.data.VerifyCode2,
              verifyCode3: this.objVerifyCustomerUser.data.VerifyCode3,
            },
          }
          BzbsProfile.RegisterSingleSignOn(params)
            .then(Response => {
              this.handleLoading(false)
              console.log('registerSingleSignOn Success Response:: ', Response)
              if (Response.data.success) {
                var params = {
                  app_id: Account.getCacheCustom('app_id'),
                  id_token: this.$route.query.id_token,
                }
                Account.actionLineDirectLogin(params, true)
                  .then(response_line => {
                    console.log('response_line ::', response_line)
                    Account.setCacheToken(response_line.data.token)
                    window.location = '/home'
                    resolve(true)
                  })
                  .catch(error => {
                    this.handleLoading(false)
                    console.log('registerSingleSignOn error ::', error)
                    if (_.isEmpty(error.response)) {
                      this.handleLoading(false)
                      this.showError = true
                      this.dataError = {
                        title: this.lbl.error.errortitle,
                        detail: this.lbl.error.connectionproblem,
                      }
                    }
                    if (this.isDebug) {
                      alert(
                        'Register Profile Error => ' +
                          JSON.stringify(error.response),
                      )
                    }
                    if (
                      error.response.data.error.message == 'DuplicateEmail' &&
                      error.response.data.error.id == 2089
                    ) {
                      this.showError = true
                      this.dataError = {
                        title: this.lbl.error.errortitle,
                        detail: this.lbl.error.emailregistered,
                      }
                    } else if (error.response.data.error.id == 2078) {
                      this.isphoneerror = true
                      this.showError = true
                      this.dataError = {
                        title: this.lbl.error.errortitle,
                        detail: this.lbl.error.contactnumberregistered,
                      }
                    } else {
                      this.showError = true
                      this.dataError = {
                        title: this.lbl.error.errortitle,
                        detail: error.response.data.error.message,
                      }
                    }
                    resolve(false)
                  })
              } else {
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: Response.data.message
                    ? Response.data.message
                    : this.lbl.error.connectionproblem,
                }
              }
            })
            .catch(error => {
              this.handleLoading(false)
              console.log('registerSingleSignOn error ::', error)

              if (_.isEmpty(error.response)) {
                this.handleLoading(false)
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: this.lbl.error.connectionproblem,
                }
              }
              if (this.isDebug) {
                alert(
                  'Register Profile Error => ' + JSON.stringify(error.response),
                )
              }
              if (
                error.response.data.error.message == 'DuplicateEmail' &&
                error.response.data.error.id == 2089
              ) {
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: this.lbl.error.emailregistered,
                }
              } else if (error.response.data.error.id == 2078) {
                this.isphoneerror = true
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: this.lbl.error.contactnumberregistered,
                }
              } else if (error.response.data.error.id == 401) {
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: error.response.data.error.message,
                }
                if (this.loginType.toLowerCase().includes('device')) {
                  window.location = window.location.origin + '/landing/email'
                }
                if (this.loginType.toLowerCase().includes('line')) {
                  var fullPath = Account.getCacheCustomByAppId('fullPath')
                  if (fullPath) {
                    window.location = window.location.origin + fullPath
                  } else {
                    this.showError = true
                  }
                }
              } else {
                this.showError = true
                this.dataError = {
                  title: this.lbl.error.errortitle,
                  detail: error.response.data.error.message,
                }
              }
              resolve(false)
            })
        } else {
          resolve(true)
        }
      })
    },
    registerSuccess() {
      if (this.isBrandA && this.isCompany && this.directBrandAUrl) {
        var token = Account.getCacheToken() ? Account.getCacheToken() : null
        var directUrl = this.directBrandAUrl
        if (directUrl.includes('?')) {
          directUrl =
            directUrl +
            '&token=' +
            token +
            '&app_id=' +
            Account.getCacheCustom('app_id')
        } else {
          directUrl =
            directUrl +
            '?token=' +
            token +
            '&app_id=' +
            Account.getCacheCustom('app_id')
        }
        window.open(encodeURI(directUrl), '_self')
      } else {
        window.location =
          '/home?app_id=' +
          Account.getCacheCustom('BzbsUser_' + Account.getCacheCustom('app_id'))
            .appId
      }
    },
    gotoBack() {
      console.log('go to ', this.$route)
      if (this.$route.query.goback == 'companycrm') {
        window.location = '/companycrm'
      } else {
        window.location = '/selectpage'
      }
    },
    ChangeError(event) {
      this.showError = event
      this.dataError = {}
    },
    ChangeCloseOtp(event) {
      this.isSentOtp = event.value
      if (event.error) {
        this.showError = true
        this.dataError = {
          title: this.lbl.error.errortitle,
          detail: event.error,
        }
      }
    },
  },
}
</script>

<style lang="scss" scope>
@import '@/style/_mixin.scss';
.auto-register-wrapper {
  position: relative;
  padding-top: 182px;
  background-repeat: round;
  background-size: contain;

  .auto-register-body {
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    background-color: #ffffff;
    margin-bottom: 47px;
    padding: 16px;
    position: relative;
    top: 1px;
    right: 0;
    left: 0;

    .head-section {
      display: flex;
      padding: 16px 0;
      border-bottom: 1px solid $color-line;

      .logo-auto-register {
        width: 56px;
        height: 56px;
        border-radius: 56px;
      }
      .auto-register-title {
        font-size: 20px;
        margin-left: 16px;
        color: $color-text-dark;
        font-weight: 700;
      }
    }

    .form-register-section {
      margin: 24px 0;

      display: flex;
      flex-direction: column;
      font-size: 14px;
      color: #424242;

      .form-title {
        font-size: 16px;
        font-weight: 600;
        color: #212121;
        margin-bottom: 16px;
      }

      .line {
        height: 1px;
        width: 100%;
        background-color: $color-line;
        margin: 24px 0;
      }
      .reference-1-container {
        margin-bottom: 24px;
      }

      .mobile-number-input {
        width: 100%;
        padding: 14px 16px;
        padding-left: 42px;
        margin-bottom: 4px;
        margin-top: 4px;
        border-radius: 8px;
        border: solid 1px #ccc;
        background-color: #fff;
        background-image: url(../../assets/images/mobile-icon.svg);
        background-repeat: no-repeat;
        background-position: 2%;

        ::placeholder {
          color: #bdbdbd;
        }
      }

      .input-container {
        position: relative;

        .reference-input {
          width: 100%;
          padding: 14px 16px;
          margin-bottom: 4px;
          margin-top: 4px;
          border-radius: 8px;
          border: solid 1px #ccc;

          ::placeholder {
            color: #bdbdbd;
          }
        }

        .clear-text-button {
          border: 0;
          background: transparent;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          padding: 0;
          margin-right: 18px;
        }
      }

      .error {
        border-color: $color-error !important;
      }

      .error-text {
        font-size: 12px;
        color: $color-error;
      }

      .manaul-detail-section {
        color: $color-body;
        margin-top: 20px;
        font-size: 14px;
        text-align: left;
      }

      .submit-button {
        align-items: center;
        padding: 16px 24px;
        border-radius: 100px;
        font-size: 16px;
        opacity: 1;
        margin-top: 42px;
      }
      .disable {
        opacity: 0.5;
      }
    }
  }
}

//Tablet
@media only screen and (min-device-width: 768px) {
  .auto-register-wrapper {
    min-height: 100vh;
    background-size: cover;
    padding: 182px 0 182px;

    .auto-register-body {
      max-width: 768px;
      width: 65%;
      height: fit-content;
      margin: auto;
      border-radius: 10px;

      .head-section {
        position: absolute;
        top: 10%;
        left: 0;
        right: 0;
        flex-direction: column;
        align-items: center;
        border-bottom: 1px solid $color-line;

        .logo-auto-register {
          width: 110px;
          height: 110px;
          border-radius: 56px;
        }
        .auto-register-title {
          font-size: 20px;
          margin: 0;
          margin-top: 4px;
          color: $color-text-dark;
          font-weight: 700;
          text-align: center;
        }
      }
      .form-register-section {
        margin-top: 164px;
        text-align: left;
      }
    }
  }
}
</style>
